import React from 'react';
import './QualifiersSection.css';

const QualifiersSection = ({ onBookNowClick }) => {
  return (
    <section className="qualifiers-section">
      <div className="qualifiers-content">
        <h2 className="qualifiers-heading"></h2>
        <p className="qualifiers-body-text">
          Having confidence in your home and business technician makes a big difference. Our mission is to always send highly-skilled, neat and friendly electricians to your front door.
        </p>
        <div className="qualifiers-bullet-points">
          <div className="bullet-column">
            <ul>
              <li>Calgary family-owned and operated</li>
              <li>Over 40 years of combined experience</li>
            </ul>
          </div>
          <div className="bullet-column">
            <ul>
              <li>Quality work for great prices</li>
              <li>Neat, clean and friendly</li>
            </ul>
          </div>
        </div>
        <button className="schedule-appointment-button" onClick={onBookNowClick}>
          Schedule Appointment
        </button>
      </div>
    </section>
  );
};

export default QualifiersSection;